<div class="bg-white rounded-lg p-6 h-full min-h-[400px] flex flex-wrap items-center justify-center gap-3">
  <div class="flex items-center justify-center mb-4">
    @if (paymentStore.txInfo?.()?.isQuoteExpired) {
      <mat-icon [svgIcon]="'status-warning'" class="[&&]:w-40 [&&]:h-40"></mat-icon>
    } @else {
      <mat-icon [svgIcon]="'status-success'" class="[&&]:w-40 [&&]:h-40"></mat-icon>
    }
  </div>
  <h2 class="w-full font-bold text-center mb-2 text-base md:text-2xl">
    @if (paymentStore.txInfo?.()?.isQuoteExpired) {
      {{ 'oopsThatTookAWhile' | translate }}
      <br />
      <span class="text-center font-medium text-sm md:text-base">{{
        'butDontWorryYourPaymentIsBeing' | translate
      }}</span>
    } @else {
      {{ 'payment_flow.PaymentSuccessful' | translate }}!!
    }
  </h2>
  <p class="w-full text-[#929292] text-center font-medium text-sm md:text-base" [innerHTML]="getSuccessPhrase()"></p>
  @if (paymentStore.txInfo?.()?.isQuoteExpired) {
    <p class="w-full text-[#929292] text-center font-medium text-sm md:text-base">
      {{ 'yourTransactionIsBeingManuallyReviwedBeforeYourpaymentIsAvailableOnYourAccount' | translate }}
    </p>
  }
  <div class="flex justify-center mt-6">
    <app-nicky-button variant="primary" (click)="redirectAfterPayment()">
      {{ authStore.authenticated() ? ('backToDashboard' | translate) : ('createAnAccount' | translate) }}
    </app-nicky-button>
  </div>
</div>
